import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './text.scss'

const Text = forwardRef(
	(
		{
			className,
			children,
			color,
			size,
			uppercase,
			capitalize,
			weight,
			icon,
			inline,
		},
		ref
	) => {
		const textClass = 'o-text'
		const cssClasses = classNames(
			textClass,
			size && `${textClass}--size-${size}`,
			color && `${textClass}--color-${color}`,
			uppercase && `${textClass}--uppercase`,
			capitalize && `${textClass}--capitalize`,
			weight && `${textClass}--weight-${weight}`,
			icon && `${textClass}--has-icon`,
			inline && `${textClass}--inline`,
			className
		)

		return (
			<div ref={ref} className={cssClasses}>
				{icon}
				{children}
			</div>
		)
	}
)

Text.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
	color: PropTypes.oneOf(['light', 'dark', 'scheme']),
	size: PropTypes.oneOf(['small', 'large', 'x-large', 'huge', 'inherit']),
	weight: PropTypes.oneOf(['light', 'regular', 'bold']),
	uppercase: PropTypes.bool,
	capitalize: PropTypes.bool,
	icon: PropTypes.node,
	inline: PropTypes.bool,
}

Text.defaultProps = {
	className: null,
	children: null,
	color: null,
	size: null,
	weight: 'regular',
	uppercase: false,
	capitalize: false,
	icon: null,
	inline: false,
}

export default Text
